import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import type { RootState } from '../app/store'
import { InputFormData } from './types';

interface TradeState {
    buyPaymentMode: "Manual" | "Prompt" | undefined;
    buyDirectChannel: string | undefined;
    previewInfo: BuyPreviewInfo | undefined;
    inputFormData: InputFormData | undefined;
    showTradeModal: boolean;
    paymentId?: number | undefined;
    benficiaryPayment?: BeneficiaryPayment[]

}

const initialState: TradeState = {
    buyPaymentMode: undefined,
    buyDirectChannel: undefined,
    previewInfo: undefined,
    inputFormData: undefined,
    showTradeModal: false,
    paymentId: undefined,
    // benficiaryPayment: undefined
}

export const tradeSlice = createSlice({
    name: 'trade',
    initialState,
    reducers: {
        // The payment mode of the user when buying crypto directly. Whether  prompt or manual
        // setBuyMethod: (state, action: PayloadAction<"Manual" | "Prompt" | undefined>) => {
        //     state.buyPaymentMode = action.payload
        // },
        // setBuyChannel: (state, action: PayloadAction<string | undefined>) => {
        //     state.buyDirectChannel = action.payload
        // },
        // clearBuyDetails: (state) => {
        //     state.buyDirectChannel = undefined
        //     state.buyPaymentMode = undefined
        //     state.previewInfo = undefined
        //     state.inputFormData = undefined
        //     state.paymentId = undefined

        // },
        // setPreviewInfo: (state, action: PayloadAction<BuyPreviewInfo | undefined>) => {
        //     state.previewInfo = action.payload
        // },
        // setInputFormData: (state, action: PayloadAction<InputFormData | undefined>) => {
        //     state.inputFormData = action.payload
        // },
        // setShowTradeModal: (state, action: PayloadAction<boolean>) => {
        //     state.showTradeModal = action.payload
        // },
        setPaymentId: (state, action: PayloadAction<number | undefined>) => {
            state.paymentId = action.payload
        },
        setBeneficiaryPayment: (state, action: PayloadAction<BeneficiaryPayment>) => {
            // const addedBeneficiacry:BeneficiaryPayment[] = [...state.benficiaryPayment,{ ...action.payload, id: Math.random().toString(36) }]
            if (state?.benficiaryPayment && state.benficiaryPayment?.length >= 1) {
                state.benficiaryPayment?.push({ ...action.payload, id: Math.random().toString(36) })
            } else {
                state.benficiaryPayment = [{ ...action.payload, id: Math.random().toString(36) }]
            }
        },
        removeBeneficiaryPayment: (state, action: PayloadAction<string>) => {
            if (state?.benficiaryPayment && state.benficiaryPayment?.length > 1) {
                state.benficiaryPayment = state.benficiaryPayment?.filter((item) => item?.id !== action?.payload)

            } else {
                state.benficiaryPayment = undefined
            }
        },
        clearBeneficiaryPayment: (state) => {
            state.benficiaryPayment = undefined
        }
    }
})


export const { setPaymentId, setBeneficiaryPayment, removeBeneficiaryPayment, clearBeneficiaryPayment } = tradeSlice.actions

// Other code such as selectors can use the imported `RootState` type
export const selectTrade = (state: RootState) => state?.trade

export default tradeSlice.reducer